<template>
  <div>
    <NuxtLayout name="split">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OWNER" />

      <template #aside>
        <UIcon
          name="EscapadaLogoSmall"
          class="w-12 h-12 mb-6 text-white"
          aria-hidden="true"
        />
        <TTitle
          tag="h2"
          size="2xl"
          color="text-white"
          :bold="true"
          leading="tight"
        >
          {{ t('views.registration-owner.aside.title') }}
        </TTitle>

        <ul>
          <li
            v-for="(item, index) in asideTexts"
            :key="index"
            class="flex gap-x-2"
          >
            <UIcon
              name="i-heroicons-solid-check-badge"
              class="w-6 text-primary-300 h-6"
            ></UIcon>
            <TText
              tag="h2"
              variant="semibold"
              color="text-white"
              classes="mb-4"
            >
              {{ item }}
            </TText>
          </li>
        </ul>
      </template>

      <AuthRegisterOwner>
        <i18n-t
          keypath="auth.registrationOwner.label"
          tag="span"
          scope="global"
        >
          <template #signUp>
            <a
              class="underline text-primary-600 font-bold"
              :href="routes().login()"
            >
              {{ t('auth.registrationOwner.signUp') }}
            </a>
          </template>
        </i18n-t>
      </AuthRegisterOwner>
      <SSpacer />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
// Constants
import { CONNECTIF_PAGE_TAGS } from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { useZendeskBot } from '~/composables/useZendeskBot'

const { setHeadInfo } = useHeadInfoComposable()
const breadCrumbMenuStore = useMenuBreadcrumbStore()
useZendeskBot()

breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.register-owner'))

definePageMeta({
  layout: false,
  splitImageUrl: '/__nuxt-public/images/registration/split-side.jpeg',
  splitImageAlt: 'views.registration-owner.pageMeta.splitImageAlt',
})

setHeadInfo({
  title: t('views.registration-owner.seo.title'),
  description: t('views.registration-owner.seo.description'),
  robotsVisible: true,
  images: [
    {
      url: '/__nuxt-public/images/registration/split-side.jpeg',
      alt: t('views.registration-owner.seo.title'),
    },
  ],
})

const asideTexts: Array<string> = [
  t('views.registration-owner.aside.text1'),
  t('views.registration-owner.aside.text2'),
  t('views.registration-owner.aside.text3'),
  t('views.registration-owner.aside.text4'),
]

sendConnectifPage()
</script>
